import React from "react";
import { ReactComponent as DocxIcon } from "../../../../../../images/filetypes/docx.svg";
import { ReactComponent as PdfIcon } from "../../../../../../images/filetypes/pdf.svg";
import { ReactComponent as JpgIcon } from "../../../../../../images/filetypes/jpg.svg";
import { ReactComponent as UnknownIcon } from "../../../../../../images/filetypes/unknown.svg";

const ICONS_MAP = {
    "image/jpeg": JpgIcon,
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document": DocxIcon,
    "application/pdf": PdfIcon
};

export const FileIcon = props => {
    const { mimeType } = props;
    const FileIcon = ICONS_MAP[mimeType];
    return FileIcon ? <FileIcon /> : <UnknownIcon />;
};
